(function ($) {
  function getPreset(e, options, preset) {
    switch (preset) {
      case 'slide':
        return {
          drawer: {
            css: {
              position: 'fixed',
              [options.align]: -options.width,
              top: 0,
              zIndex: 101,
              width: options.width,
              height: '100vh',
              overflowX: 'hidden',
            },
            animate: {
              show: {
                properties: {
                  [options.align]: 0,
                },
                options: {
                  duration: options.duration,
                  specialEasing: {
                    [options.align]: options.easing,
                  },
                  start: function () {
                    e.drawer.css({display: 'block'});
                  },
                },
              },
              hide: {
                properties: {
                  [options.align]: -options.width,
                },
                options: {
                  duration: options.duration,
                  specialEasing: {
                    [options.align]: options.easing,
                  },
                  complete: function () {
                    e.drawer.css({display: 'none'});
                  },
                },
              },
            },
          },
        };
      default:
        return {};
    }
  }

  function getDefaultOptions(e, options) {
    options = Object.assign({
      width: 250,
      duration: 500,
      easing: 'easeOutCubic',
      target: $(e.trigger.data('target')),
      preset: null,
      align: 'left',
    }, options);

    options = Object.assign({
      backdrop: {
        css: {
          display: 'none',
          width: '100%',
          opacity: 0.5,
          backgroundColor: 'black',
          height: '100vh',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 100,
          pointerEvents: 'none',
        },
        animate: {
          show: {
            properties: {
              opacity: 'show',
            },
            options: {
              duration: options.duration,
              specialEasing: {
                opacity: options.easing,
              },
            },
          },
          hide: {
            properties: {
              opacity: 'hide',
            },
            options: {
              duration: options.duration,
              specialEasing: {
                opacity: options.easing,
              },
            },
          },
        },
      },
      drawer: {
        css: {
          display: 'none',
          position: 'absolute',
          [options.align]: 0,
          top: 0,
          zIndex: 101,
          width: options.width,
          height: '100vh',
          overflowX: 'hidden',
        },
        animate: {
          show: {
            properties: {
              width: 'show',
            },
            options: {
              duration: options.duration,
              specialEasing: {
                width: options.easing,
              },
            },
          },
          hide: {
            properties: {
              width: 'hide',
            },
            options: {
              duration: options.duration,
              specialEasing: {
                width: options.easing,
              },
            },
          },
        },
      },
    }, getPreset(e, options, options.preset), options);

    return options;
  }

  function init(e, options) {
    if (!e.drawer.prev().hasClass('dvae-drawer-backdrop')) {
      let backdrop = $('<div>', {class: 'dvae-drawer-backdrop'});
      backdrop.insertBefore(e.drawer);
      e.backdrop = backdrop;
    } else {
      e.backdrop = e.drawer.prev();
    }

    e.trigger.data('dvae-data', {e, options});

    e.backdrop.css(options.backdrop.css);
    e.drawer.css(options.drawer.css);

    e.trigger.unbind('click.dvae-drawer').bind('click.dvae-drawer', function () {
      toggle(e, options, 'show');
    });

    e.backdrop.unbind('click.dvae-drawer').bind('click.dvae-drawer', function () {
      toggle(e, options, 'hide');
    });
  }

  function toggle(e, options, action) {
    if (action == 'show') {
      e.backdrop.css({
        pointerEvents: 'auto',
      });
    }

    if (action == 'hide') {
      e.backdrop.css({
        pointerEvents: 'none',
      });
    }

    e.drawer.stop().animate(
      options.drawer.animate[action].properties,
      options.drawer.animate[action].options
    );

    e.backdrop.stop().animate(
      options.backdrop.animate[action].properties,
      options.backdrop.animate[action].options
    );
  }

  $.fn.dvaeDrawer = function (options) {
    let e = {};

    if (typeof options == 'string') {
      let data = $(this).data('dvae-data');

      if (!data) throw 'Element is not a dvae-effect-drawer element';

      e = data.e;
      let o = data.options;

      switch (options) {
        case 'show':
          toggle(e, o, options);
          break;
        case 'hide':
          toggle(e, o, options);
          break;
        default:
          throw 'Not a dvae-effect-drawer method';
      }
    } else {
      e.trigger = $(this);

      options = getDefaultOptions(e, options);

      e.drawer = options.target;

      init(e, options);
    }

    return this;
  };
})(jQuery);
